import api from './axios';

export async function register(nome, email, password) {
  const { data } = await api.post('/auth/register', { nome, email, password });
  return data; // { user, token }
}

export async function login(email, password) {
  const { data } = await api.post('/auth/login', { email, password });
  return data; // { user, token }
}

export async function forgotPassword(email) {
  const { data } = await api.post('/auth/forgot-password', { email });
  return data; // { message, success }
}

export async function changePassword(currentPassword, newPassword) {
  const { data } = await api.put('/auth/change-password', { currentPassword, newPassword });
  return data; // { message }
}
